var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-snackbar',{attrs:{"md-active":_vm.show},on:{"update:mdActive":function($event){_vm.show=$event},"update:md-active":function($event){_vm.show=$event}}},[_vm._v(_vm._s(_vm.message))])}
var staticRenderFns = []

export { render, staticRenderFns }